module.exports = __webpack_public_path__ + "static/img_2.a40101e5.jpg";